<template>
  <v-sheet class="py-10">
    <v-row class="listitem flex-wrap space-around" lines="three">
      <v-col v-for="(item, i) in items" :key="i" cols="12" md="6" lg="6">
        <v-row class="d-flex align-center">
          <v-col class="itemtitle" cols="4">{{ item.title }}</v-col>
          <v-col class="text-white text-body-1 wrap-text">
            <div v-html="item.text.replace(/<br>/g, '<br />')"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <p class="text-Body1 text-justify text-md-center mt-16 pa-5">
          本作は、発売中のNintendo Switchソフト「アパシー鳴神学園七不思議」を事前に遊んでいただくことで
          世界観や登場人物について、より深くお楽しみいただけます。<br />
          未プレイの方も問題なくお楽しみいただけますが、あわせてのプレイをおすすめいたします。</p
      >
<!-- 購入ボタン -->
<BuyButton 
  src="http://d-mebius.com/apathyreikaiki/img/bnr.png"
  href="https://store-jp.nintendo.com/item/software/D70010000110941"/>

  </v-sheet>
</template>
<script>

  import BuyButton from "./BuyButton.vue";
  export default {
    components: {
    //  campaign,
    //  subtitle,
    BuyButton
    },
    data: () => ({
      items: [
        {
          title: "タイトル",
          text: "アパシー　鳴神学園霊怪記～旧校舎の怪異～",
        },
        {
          title: "ハード",
          text: "Nintendo Switch",
        },
        {
          title: "ジャンル",
          text: "ホラーアドベンチャー",
        },
        // {
        //   title: "CERO",
        //   text: "C",
        // },
        {
          title: "発売日",
          text: "2025/12/25",
        },
        {
          title: "価格",
          text: "1,980円(税抜価格1,800円)",
        },
      ],
    }),
  };
</script>
<style scoped>
  .listitem {
    text-align: center;
    margin: 0 auto;
    padding: 30px;
  }
  .itemtitle {
    background: rgb(var(--v-theme-primary));
    font-weight: bold;
    margin: 1em;
    padding: 0.5em 1em;
    line-height: 2em;
  }
  .wrap-text {
    white-space: normal;
    line-height: 1.2em;
  }
  .image-container {
    display: flex;
    justify-content: center; /* 画像を中央揃え */
    align-items: center; /* 必要なら縦方向も中央揃え */
  }

  .responsive-image {
    max-width: 100%; /* 親要素の幅を超えない */
    height: auto; /* アスペクト比を維持 */
    display: block; /* ブロック要素として扱う */
  }
</style>
